/**
 * Unwrap a CommonJS module's default export.
 *
 * Some CJS packages without an `exports` map (e.g. react-dropdown-select,
 * react-currency-input-field) are exposed by the vite 8 / rolldown production
 * bundler as `{ default: Component }` even for a default import, while the dev
 * server (esbuild) hands back the component directly. Rendering the `{ default }`
 * object as a component throws React error #130. Unwrap defensively: if the
 * value carries a `.default`, use it; otherwise it is already the export.
 */
export function interopDefault<T>(mod: T): T {
  return ((mod as { default?: T })?.default ?? mod) as T
}
